const Data = [
    {
      id: 1,
      text: "Yavuz Selim",
      day: "Dec 12th at 2:30pm",
      bittiMi: false,
      doktor: "DR Molly Brown",
    },
    {
      id: 2,
      text: "Mihrimah Sultan",
      day: "Dec 13th at 1:30pm",
      bittiMi: true,
      doktor: "DR Molly Brown",
    },
    {
      id: 3,
      text: "Fatih Mehmet",
      day: "Dec 14th at 3:00pm",
      bittiMi: false,
      doktor: "DR Cal Hockley",
    },
    {
      id: 4,
      text: "İpek Bilir",
      day: "Dec 12th at 2:30pm",
      bittiMi: false,
      doktor: "DR Cal Hockley",
    },
    {
      id: 5,
      text: "Haluk Yilmaz",
      day: "Dec 13th at 1:30pm",
      bittiMi: true,
      doktor: "DR Jack Dawson",
    },
    {
      id: 6,
      text: "Ayşe Güler",
      day: "Dec 14th at 3:00pm",
      bittiMi: false,
      doktor: "DR Rose Bukater",
    },
  ];
  export default Data;

  export const doctorData = [
    {
        id: 1,
        doctorName: "DR Jack Dawson",
        doctorImg: "https://t4.ftcdn.net/jpg/02/60/04/09/240_F_260040900_oO6YW1sHTnKxby4GcjCvtypUCWjnQRg5.jpg", // Example doctor image
    },
    {
        id: 2,
        doctorName: "DR Rose Bukater",
        doctorImg: "https://t3.ftcdn.net/jpg/01/30/45/54/240_F_130455409_fTuinPO1LXECv5hlk9VBREnL6yowYUo3.jpg", // Example doctor image
    },
    {
        id: 3,
        doctorName: "DR Cal Hockley",
        doctorImg: "https://t3.ftcdn.net/jpg/02/95/51/80/240_F_295518052_aO5d9CqRhPnjlNDTRDjKLZHNftqfsxzI.jpg", // Example doctor image
    },
    {
        id: 4,
        doctorName: "DR Molly Brown",
        doctorImg: "https://t3.ftcdn.net/jpg/00/79/71/30/240_F_79713072_dWCAZt6wPNFG5PqooCxAGsl4Mza7UfVy.jpg", // Example doctor image
    },
];
